import React from 'react';

import { TypographyListItem } from 'components/TypographyList';

import ActionStatus from './ActionStatus';
import { IApproverListItem } from './interfaces';

export const ApproverListItem: React.FC<IApproverListItem> = ({
  name,
  role,
  signStatus,
  isPredicted,
  ...props
}) => {
  return (
    <TypographyListItem
      {...props}
      icon={isPredicted ? undefined : <ActionStatus signStatus={signStatus} />}
      type={'icon'}
    >
      {name || role}
    </TypographyListItem>
  );
};

export default ApproverListItem;
